import {corpus} from './corpus';
import _ from 'lodash';

function flattenToString(arr) {
  return arr.reduce((acc, str) => acc + str, '')
}

function getFragment(passage, limit) {

  // initialize a result array
  let result = [];

  // take a random num of sentences
  let upperBound = limit > passage.length
    ? passage.length
    : limit;

  // random sample size
  const sampleSize = Math.ceil(Math.random() * upperBound);

  // random sample start idx
  const sampleStart = Math.round(Math.random() * (passage.length - sampleSize));

  // loop through the arr and build the result
  for (let i = 0; i < sampleSize; i++) {
    result = result.concat(passage[sampleStart + i])
  }

  return result;
}

// split on a ！，？，or 。then replace with what you split

export function getPassage() {
  const key = _.sample(Object.keys(corpus));
  return _.sample(corpus[key]);
}

export function buildIpsum(paragraphNumber, paragraphLength, sources = null) {
  let used = [];
  let result = '';

  for (let i = 0; i < paragraphNumber; i++) {
    let paragraph = '';

    // paragraph formatting
    if (i > 0) {
      paragraph += '\n\n'
    }


    for (let j = 0; j < paragraphLength; j++) {
      let currentPassage = getPassage();

      // get a passage that hasn't been used before
      while (_.includes(used, currentPassage.key)) {
        currentPassage = getPassage();
      }

      // add the current passage's key to used keys
      used = used.concat(currentPassage.key);

      const fragment = getFragment(currentPassage.quote, paragraphLength - j);

      // update the sentence count, if the fragment contains more than one sentence
      if (fragment.length > 1) {
        j += fragment.length - 1;
      }

      // append to the result
      paragraph += flattenToString(fragment);

    }

    result += paragraph
  }
  return result;
}